import { ReactNode } from 'react';
import { BottomNav } from './BottomNav';

export function Shell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col max-w-md mx-auto relative bg-bg">
      <main className="flex-1 overflow-y-auto pb-24">{children}</main>
      <BottomNav />
    </div>
  );
}
